import { useCallback } from 'react'
import { Toast } from '@shopify/polaris'

const CustomToast = ({message, active, setActive}) => {

  const toggleActive = useCallback(() => setActive((active) => !active), [])

  const toastMarkup = active ? (
    <Toast content={message} onDismiss={toggleActive} />
  ) : null

  return (
    toastMarkup
  )
}

export default CustomToast
